import { ICardElementWithChildren } from "backend/model/model";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
import MeasureTable from "./MeasureTable";
import { ColumnDefinition, ElementWithId } from "./MeasureTableTypes";

const useStyles = makeThemedStyles("mytasks", (theme) => ({
  pill: {
    color: "rgba(17, 94, 103, 1)",
    border: "0.15em solid rgba(17, 94, 103, 1)",
    height: "1.8em",
    margin: "2em",
    display: "flex",
    padding: "15px",
    fontSize: "12px",
    minWidth: "4.66em",
    marginTop: "1.3em",
    alignItems: "center",
    fontWeight: 500,
    lineHeight: "2em",
    marginLeft: "0em",
    whiteSpace: "nowrap",
    marginRight: "1em",
    borderRadius: "2em",
    marginBottom: "1.5em",
    justifyContent: "center",
    backgroundColor: "rgb(207,223,224)",
  },
  nameCellContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  workflowStatus: {
    display: "flex",
    maxWidth: "190px",
    minWidth: "72px",
    marginTop: "16px",
    paddingTop: "3px",
    borderRadius: "35px",
    paddingBottom: "3px",
    justifyContent: "center",
    color: "rgb(227, 181, 7)",
    backgroundColor: "rgba(227, 181, 7, 0.063)",
    alignItems: "center",
    marginBottom: "16px",
  },
  table: {
    width: "100%",
    overflow: "hidden",
    minWidth: "unset",
    "& th": {
      borderBottom: "unset",
      color: "rgb(116, 122, 135)",
      fontSize: 14,
      background: "transparent",
    },
    "& tr": {
      borderRadius: 15,
      marginBottom: 10,
      color: "#4C5157",
      marginLeft: 56,
      marginRight: 72,
      paddingLeft: 16,
      justifyContent: "space-between",
    },
    "& tbody tr": {
      backgroundColor: "#F7F9FA",
    },
    "& tbody td": {
      alignItems: "center",
      justifyContent: "center",
      borderBottom: "unset",
      minWidth: "50px",
    },
    "& tbody td > div": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      borderBottom: "unset",
      minWidth: "50px",
      height: "40px",
    },
  },
  pageContainer: {
    background: "#edf3f4",
    height: "100vh",
    minWidth: "unset",
  },
}));

const MyTasksTable = <T extends ElementWithId>(props: {
  width?: string;
  maxHeight?: string;
  items: ICardElementWithChildren[];
  columns: ColumnDefinition<ICardElementWithChildren>[];
  className?: string;
}) => {
  const styles = useStyles();
  return (
    <>
      <MeasureTable
        className={styles.table}
        items={props.items}
        columns={props.columns}
      />
    </>
  );
};

export default MyTasksTable;
